import { render, staticRenderFns } from "./HotelsAdvancedDetailStaffAccommodation.vue?vue&type=template&id=4d821f59&scoped=true&"
import script from "./HotelsAdvancedDetailStaffAccommodation.vue?vue&type=script&lang=js&"
export * from "./HotelsAdvancedDetailStaffAccommodation.vue?vue&type=script&lang=js&"
import style0 from "./HotelsAdvancedDetailStaffAccommodation.vue?vue&type=style&index=0&id=4d821f59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d821f59",
  null
  
)

export default component.exports